import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.equineStone
};
export default anchor;